import React, { useState, useEffect, useCallback } from 'react';
import { Container } from 'react-bootstrap';
import { toast } from 'react-toastify';
import Header from '~/Components/Header/Header';
import Loading from '~/Components/Loading';
import { extrairMensagemErro } from '~/Utils/Helpers';
import {
  obterRelatorioChequesProrrogados,
  listarGrupoEmpresaChequesProrrogados,
  listarGrupoGEChequesProrrogados,
  listarContasPorGE,
} from '~/Services/Service';
import FiltrosChequesProrrogados from './FiltrosChequesProrrogados';
import TabelaChequesProrrogados from './TabelaChequesProrrogados';

const ChequesProrrogados = () => {
  const [gruposEmpresa, setGruposEmpresa] = useState([]);
  const [gruposGe, setGruposGe] = useState([]);
  const [contasGe, setContasGe] = useState([]);
  const [carregandoLookups, setCarregandoLookups] = useState(true);
  const [carregandoContas, setCarregandoContas] = useState(false);
  const [carregandoRelatorio, setCarregandoRelatorio] = useState(false);
  const [resultado, setResultado] = useState(null);
  const [geSelecionada, setGeSelecionada] = useState(null);

  useEffect(() => {
    let ativo = true;
    const carregarLookupsIniciais = async () => {
      try {
        const [respGes, respGruposGe] = await Promise.all([
          listarGrupoEmpresaChequesProrrogados(),
          listarGrupoGEChequesProrrogados(),
        ]);
        if (!ativo) return;
        setGruposEmpresa(respGes || []);
        setGruposGe(respGruposGe || []);
      } catch (err) {
        if (!ativo) return;
        toast.error(extrairMensagemErro(err));
      } finally {
        if (ativo) setCarregandoLookups(false);
      }
    };
    carregarLookupsIniciais();
    return () => {
      ativo = false;
    };
  }, []);

  useEffect(() => {
    if (geSelecionada == null) {
      setContasGe([]);
      return undefined;
    }
    let ativo = true;
    setCarregandoContas(true);
    listarContasPorGE(geSelecionada)
      .then((resp) => {
        if (!ativo) return;
        setContasGe(resp || []);
      })
      .catch((err) => {
        if (!ativo) return;
        setContasGe([]);
        toast.error(extrairMensagemErro(err));
      })
      .finally(() => {
        if (ativo) setCarregandoContas(false);
      });
    return () => {
      ativo = false;
    };
  }, [geSelecionada]);

  const handleSubmit = useCallback(async (filtros) => {
    setCarregandoRelatorio(true);
    try {
      const resp = await obterRelatorioChequesProrrogados(filtros);
      setResultado(resp);
    } catch (err) {
      setResultado(null);
      toast.error(extrairMensagemErro(err));
    } finally {
      setCarregandoRelatorio(false);
    }
  }, []);

  const handleCancelar = useCallback(() => {
    setResultado(null);
    setGeSelecionada(null);
    setContasGe([]);
  }, []);

  const handleGeChange = useCallback((novaGe) => {
    setGeSelecionada(novaGe);
  }, []);

  return (
    <Container fluid className="mb-4 mt-3">
      <Header title="Cheques Prorrogados" />
      {carregandoLookups ? (
        <Loading />
      ) : (
        <>
          <FiltrosChequesProrrogados
            gruposEmpresa={gruposEmpresa}
            gruposGe={gruposGe}
            contasGe={contasGe}
            carregandoContas={carregandoContas}
            onGeChange={handleGeChange}
            onSubmit={handleSubmit}
            onCancelar={handleCancelar}
            submitting={carregandoRelatorio}
          />
          {carregandoRelatorio ? (
            <Loading />
          ) : (
            resultado && <TabelaChequesProrrogados resultado={resultado} />

          )}
        </>
      )}
    </Container>
  );
};

export default ChequesProrrogados;
